<template>
  <v-container>
    <Alert
      :show-alert="success"
      type="success"
      :text="$t('schoolSetup.complete.success')"
      :subtext="$t('schoolSetup.complete.title')"
      :timeout="3000"
      position="Bottom"
      @input="onclosesuccess"
    />
    <FullscreenDialog
      title=""
      v-model="addNewSchool"
    >
      <template slot="content">
        <v-container class="px-5 py-4">
          <Alert
            :show-alert="error"
            type="error"
            :text="$t('schoolSetup.error.title')"
            :subtext="$t('schoolSetup.error.subtitle')"
            :timeout="3000"
            position="Bottom"
            @input="onclose"
          />
          <v-row>
            <v-col>
              <h1>
                {{ $t("schoolSetup.addSchool.another") }}
              </h1>
              <v-autocomplete
                v-model="school"
                ref="selectSchool"
                @keyup.enter="handleEnter()"
                :items="filteredSchools"
                :placeholder="$t('schoolSetup.addSchool.placeholder')"
                prepend-inner-icon="mdi-magnify"
                :clearable="true"
                item-text="name"
                :menu-props="{ maxHeight: 200 }"
                return-object
                :autofocus="true"
                :search-input.sync="inputText"
                :no-data-text="filter()"
              />
            </v-col>
          </v-row>
        </v-container>
      </template>
    </FullscreenDialog>
    <FullscreenDialog
      title=""
      v-model="aboutThisApp"
    >
      <template slot="content">
        <v-container class="px-5">
          <v-row>
            <v-col>
              <h1>
                {{ $t("settings.aboutThisApp") }}
              </h1>
              <p>
                The NSW Education Parent App is a companion application to the
                School Website Service from the NSW Department of Education
              </p>
              <p>
                News and events published by your chosen schools will appear in
                this app. Through push notification alerts, you will keep up to
                date with the latest information. Functionality will continue to
                be added.
              </p>
            </v-col>
          </v-row>
        </v-container>
      </template>
    </FullscreenDialog>
    <FullscreenDialog
      :title="$t('localeSelection.title')"
      v-model="selectLocale"
    >
      <template slot="content">
        <LocaleSelector />
      </template>
    </FullscreenDialog>

    <v-row>
      <v-col class="pt-1">
        <v-list class="py-0">
          <v-subheader class="px-0 ads-blue-2">
            {{ $t("settings.myAccount") }}
          </v-subheader>
          <v-list-item
            class="px-0 mb-3"
            v-if="!user"
          >
            <v-card
              flat
              outlined
              color="#ebebeb"
            >
              <div class="flex-grow-1 text-left school-name pa-3">
                <div class="d-flex align-start mb-5">
                  <v-img
                    src="/service_nsw.png"
                    class="mr-3"
                    max-width="121"
                  />
                  <div
                    class="text-body-1"
                    style="line-height: 1.1; margin-top: 3px;"
                  >
                    <span v-html="$t('settings.snsw.desc')" />
                  </div>
                </div>
                <v-btn
                  color="primary"
                  large
                  elevation="0"
                  @click="login"
                >
                  <v-icon
                    left
                    dark
                  >
                    mdi-link
                  </v-icon>
                  {{ $t("settings.snsw.signin") }}
                </v-btn>
              </div>
            </v-card>
          </v-list-item>
          <v-list-item
            class="px-0 mb-3"
            v-else-if="user && user != 'error'"
          >
            <v-card
              flat
              outlined
              color="#ebebeb"
              class="flex-grow-1"
            >
              <div class="flex-grow-1 text-left school-name pa-3">
                <div class="d-flex align-start mb-5">
                  <v-img
                    src="/service_nsw.png"
                    class="mr-3"
                    max-width="121"
                  />
                  <div
                    class="text-body-1"
                    style="line-height: 1.1; word-break: break-all; margin-top: 3px;"
                  >
                    <div class="font-weight-bold">
                      {{ user.given_name }} {{ user.family_name }}
                    </div>
                    <div>
                      {{ user.email }}
                    </div>
                  </div>
                </div>
                <v-btn
                  color="success"
                  large
                  @click="logout"
                  text
                >
                  <v-icon
                    left
                    dark
                  >
                    mdi-logout-variant
                  </v-icon>
                  {{ $t("settings.snsw.signout") }}
                </v-btn>
              </div>
            </v-card>
          </v-list-item>
          <v-list-item
            class="px-0 mb-3"
            v-else
          >
            <v-card
              flat
              outlined
              color="#ebebeb"
              class="flex-grow-1"
            >
              <div class="flex-grow-1 text-left school-name pa-3">
                <div class="d-flex align-start mb-5">
                  <v-img
                    src="/service_nsw.png"
                    class="mr-3"
                    max-width="121"
                  />
                  <div
                    class="text-body-1 error--text"
                    style="line-height: 1.1"
                  >
                    <div class="font-weight-bold d-flex align-center mb-1">
                      <v-icon
                        left
                        dark
                        color="error"
                      >
                        mdi-alert
                      </v-icon>
                      Error
                    </div>
                    <div>
                      {{ $t("settings.snsw.error") }}
                    </div>
                  </div>
                </div>
                <v-btn
                  color="error"
                  large
                  @click="login"
                >
                  <v-icon
                    left
                    dark
                  >
                    mdi-refresh
                  </v-icon>
                  {{ $t("settings.snsw.retry") }}
                </v-btn>
              </div>
            </v-card>
          </v-list-item>
        </v-list>
        <v-list class="py-0">
          <v-subheader class="px-0 ads-blue-2">
            {{ $t("settings.school.settings") }}
          </v-subheader>
          <!-- <v-list-item class="px-0 mb-5" @click="personalisation = true">
            <v-list-item-icon class="my-1 mr-4">
              <v-icon>
                mdi-file-find-outline
              </v-icon>
            </v-list-item-icon>
            <v-list-item-content class="pa-0">
              <v-list-item-title>
                Personalise content feeds
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item> -->
          <v-list-item class="px-0">
            <v-expansion-panels
              flat
              v-model="panel"
            >
              <v-expansion-panel
                v-for="(school, i) in mySchools"
                :key="i"
              >
                <v-expansion-panel-header class="px-0 py-3">
                  <div
                    class="d-flex align-center"
                    style="width: calc(100% - 24px)"
                  >
                    <div
                      class="school-logo"
                      :style="`border-color: ${school.details.colour}`"
                    >
                      <v-img
                        :src="school.details.logo"
                        width="22"
                        height="22"
                        contain
                        class="flex-shrink-0 flex-grow-0"
                      />
                    </div>
                    <div
                      class="mb-0 ml-4 mr-1"
                      style="width: calc(100% - 60px)"
                    >
                      <div
                        class="text-truncate font-weight-medium"
                        style="line-height: 1.5rem; font-size: 1.125rem;"
                      >
                        {{ school.details.name }}
                      </div>
                    </div>
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-list>
                    <v-subheader class="px-0 ads-blue-2">
                      {{ $t("settings.school.manageNotifications") }}
                    </v-subheader>
                    <template v-if="supportsI18n">
                      <v-list-item class="px-0 my-4">
                        <v-list-item-action class="my-1">
                          <v-switch
                            :input-value="school.pushNotifications.news"
                            @change="
                              togglePushNotifications(
                                $event,
                                school.schoolId,
                                'news'
                              )
                            "
                          />
                        </v-list-item-action>
                        <v-list-item-content class="pa-0">
                          <v-list-item-title>
                            {{ $t("settings.school.news") }}
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item class="px-0 my-4">
                        <v-list-item-action class="my-1">
                          <v-switch
                            :input-value="school.pushNotifications.event"
                            @change="
                              togglePushNotifications(
                                $event,
                                school.schoolId,
                                'event'
                              )
                            "
                          />
                        </v-list-item-action>
                        <v-list-item-content class="pa-0">
                          <v-list-item-title>
                            {{ $t("settings.school.calendar") }}
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item class="px-0 my-4">
                        <v-list-item-action class="my-1">
                          <v-switch
                            :input-value="school.pushNotifications.newsletter"
                            @change="
                              togglePushNotifications(
                                $event,
                                school.schoolId,
                                'newsletter'
                              )
                            "
                          />
                        </v-list-item-action>
                        <v-list-item-content class="pa-0">
                          <v-list-item-title>
                            {{ $t("settings.school.newsletters") }}
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>

                      <!-- TODO: Re-enable in the future -->
                      <!-- <v-list-item class="px-0 my-4">
                        <v-list-item-action class="my-1">
                          <v-switch
                            :input-value="school.pushNotifications.reminder"
                            @change="togglePushNotifications($event, school.schoolId, 'reminder')"
                          />
                        </v-list-item-action>
                        <v-list-item-content class="pa-0">
                          <v-list-item-title>
                            Event Reminders
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item> -->
                    </template>
                    <template v-else>
                      <v-list-item class="px-0">
                        <v-list-item-action class="my-1">
                          <v-switch
                            :input-value="school.pushNotifications.general"
                            @change="
                              togglePushNotifications(
                                $event,
                                school.schoolId,
                                'general'
                              )
                            "
                          />
                        </v-list-item-action>
                        <v-list-item-content class="pa-0">
                          <v-list-item-title>
                            Enable push notifications
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </template>
                  </v-list>
                  <AdsButton
                    :tertiary="true"
                    color="error"
                    @click="removeSchool(school)"
                    icon="mdi-minus-circle-outline"
                    :button-text="$t('settings.removeSchool')"
                    class="px-0"
                  />
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-list-item>
          <v-list-item class="px-0 mb-3 mt-4">
            <AdsButton
              :tertiary="true"
              @click="addNewSchool = true"
              color="primary"
              icon="mdi-plus-circle-outline"
              :button-text="$t('settings.addSchool')"
              class="px-0"
            />
          </v-list-item>
        </v-list>
        <v-divider class="mb-3 mx-n5" />
        <v-list class="py-0">
          <v-subheader class="px-0 ads-blue-2">
            {{ $t("settings.information") }}
          </v-subheader>
          <v-list-item
            class="px-0 mb-5"
            @click="openLocaleSelector()"
            v-if="parseInt(appBuild) >= nonMandatoryNotification"
          >
            <v-list-item-icon class="my-1 mr-4">
              <v-icon class="material-icons-outlined ads-blue-2">
                mdi-web
              </v-icon>
            </v-list-item-icon>
            <v-list-item-content class="pa-0">
              <v-list-item-title>
                {{ $t("settings.appLanguage") }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            class="px-0 mb-5"
            @click="openLink(remoteConfig('termsConditionsUrl'))"
          >
            <v-list-item-icon class="my-0 mr-4">
              <v-icon class="material-icons-outlined ads-blue-2">
                mdi-file-find-outline
              </v-icon>
            </v-list-item-icon>
            <v-list-item-content class="pa-0">
              <v-list-item-title>
                {{ $t("settings.termsAndConditions") }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            class="px-0 mb-5"
            @click="openAboutThisApp()"
          >
            <v-list-item-icon class="my-1 mr-4">
              <v-icon class="material-icons-outlined ads-blue-2">
                mdi-information-outline
              </v-icon>
            </v-list-item-icon>
            <v-list-item-content class="pa-0">
              <v-list-item-title>
                {{ $t("settings.aboutThisApp") }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <!-- <v-list-item
            class="px-0 mb-5"
            @click="emailLink('parentapp@detcorpcomms.zendesk.com')"
          >
            <v-list-item-icon class="my-1 mr-4">
              <v-icon class="material-icons-outlined ads-blue-2">
                mdi-email-outline
              </v-icon>
            </v-list-item-icon>
            <v-list-item-content class="pa-0">
              <v-list-item-title>Share feedback</v-list-item-title>
            </v-list-item-content>
          </v-list-item> -->
          <v-list-item
            class="px-0 mb-5"
            @click="$store.dispatch('resetWhatsNewHistory')"
            v-if="
              environment == 'dev' ||
                environment == 'test' ||
                environment == 'pre'
            "
          >
            <v-list-item-icon class="my-1 mr-4">
              <v-icon class="material-icons-outlined ads-blue-2">
                mdi-alert-outline
              </v-icon>
            </v-list-item-icon>
            <v-list-item-content class="pa-0">
              <v-list-item-title>Reset whats new history</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
        <v-list v-if="debug == 'true'">
          <v-list-item
            class="px-0 mb-5"
            v-for="(cookie, name) in cookies"
            :key="name"
          >
            <v-list-item-icon class="my-1 mr-4">
              <v-icon class="material-icons-outlined ads-blue-2">
                mdi-information-outline
              </v-icon>
            </v-list-item-icon>
            <v-list-item-content class="pa-0">
              <div style="word-break: break-all">
                {{ name }}: {{ cookie }}
              </div>
            </v-list-item-content>
          </v-list-item>
          <v-list-item class="px-0 mb-5">
            <v-list-item-icon class="my-1 mr-4">
              <v-icon class="material-icons-outlined ads-blue-2">
                mdi-information-outline
              </v-icon>
            </v-list-item-icon>
            <v-list-item-content class="pt-2">
              <div
                style="word-break: break-all"
                class="mb-2"
              >
                EdPush /register-UUID:
              </div>
              <div
                v-for="(item, name) in registerUUID"
                :key="name"
              >
                <strong>{{ name }}</strong>: {{ item }}
              </div>
            </v-list-item-content>
          </v-list-item>
          <v-list-item class="px-0 mb-5">
            <v-list-item-icon class="my-1 mr-4">
              <v-icon class="material-icons-outlined ads-blue-2">
                mdi-information-outline
              </v-icon>
            </v-list-item-icon>
            <v-list-item-content class="pt-2">
              <div
                style="word-break: break-all"
                class="mb-2"
              >
                School Updates /register:
              </div>
              <div
                v-for="(item, name) in register"
                :key="name"
              >
                <strong>{{ name }}</strong>: {{ item }}
              </div>
            </v-list-item-content>
          </v-list-item>
          <v-list-item class="px-0 mb-5">
            <v-list-item-icon class="my-1 mr-4">
              <v-icon class="material-icons-outlined ads-blue-2">
                mdi-information-outline
              </v-icon>
            </v-list-item-icon>
            <v-list-item-content class="pt-2">
              <div
                style="word-break: break-all"
                class="mb-2"
              >
                /watch GET:
              </div>
              <div
                v-for="(item, name) in schoolStatus"
                :key="name"
                class="mb-4"
              >
                <div class="text-h6 mb-2">
                  <strong>{{ name }}</strong>
                </div>
                <div
                  v-for="(obj, index) in item"
                  class="mb-4"
                  :key="index"
                >
                  <div
                    v-for="(a, b) in obj"
                    :key="b"
                  >
                    <strong>{{ b }}</strong>: {{ a }}
                  </div>
                </div>
              </div>
            </v-list-item-content>
          </v-list-item>
        </v-list>
        <div style="font-size:14px">
          {{ $t("settings.appBuild") }}: {{ appBuild }}
        </div>
        <div style="font-size:14px">
          {{ $t("settings.appVersion") }}: {{ appVersion }}
        </div>
        <div style="font-size:14px">
          {{ $t("settings.build") }}: {{ packageInfo.version.split("-")[1] }}
        </div>
        <div style="font-size:14px">
          {{ $t("settings.version") }}: {{ packageInfo.version.split("-")[0] }}
        </div>
        <div style="font-size:14px">
          {{ $t("settings.environment") }}: {{ environment }}
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import {
  FullscreenDialog,
  AdsButton,
  AdsSelect,
  AdsTextField,
  AdsTextArea,
  AdsExpansionPanel,
  Alert
} from "@nswdoe/doe-ui-core";
import { mapGetters } from "vuex";
import NewsFilter from "../components/NewsFilter";
import features from "../features.json";
import {
  FA_SCREEN_CLASS,
  FA_SCREEN_NAME,
  FA_SCREEN_VIEW
} from "@/settings/constants";
import LocaleSelector from "@/components/LocaleSelector.vue";
import packageInfo from "../../package.json";
import { getCookie } from "@/mixins/cookies";

const Settings = {
  computed: {
    ...mapGetters({
      allSchools: "schools",
      mySchools: "mySchools",
      appID: "appID",
      schoolStatus: "schoolStatus",
      registerUUID: "registerUUID",
      register: "register",
      user: "user"
    }),
    filteredSchools: function() {
      let res = [];
      res = this.allSchools.filter(el => {
        return !this.mySchools.find(element => {
          return element.schoolCode == el.code;
        });
      });
      return this.inputText ? res : [];
    },
    fcmToken: function() {
      return this.getCookie("fcmToken");
    },
    appBuild: function() {
      return this.getCookie("appbuild");
    },
    appVersion: function() {
      return this.getCookie("appversion");
    },
    debug: function() {
      // because Doris doesn't want to see access token
      // return false;
      return this.getCookie("debug");
    },
    cookies: function() {
      var pairs = document.cookie.split(";");
      var cookies = {};
      for (var i = 0; i < pairs.length; i++) {
        var pair = pairs[i].split("=");
        cookies[(pair[0] + "").trim()] = unescape(pair.slice(1).join("="));
      }
      return cookies;
    },
    packageInfo: function() {
      return packageInfo;
    },
    environment: function() {
      return process.env.VUE_APP_API_ENVIRONMENT;
    },
    accessToken: function() {
      return this.getCookie("accessToken");
    },
    nonMandatoryNotification: function() {
      return features.nonMandatoryNotification;
    },
    supportsI18n: function() {
      return parseInt(this.appBuild) >= features.internationalisation;
    }
  },
  components: {
    FullscreenDialog,
    AdsButton,
    AdsSelect,
    AdsTextField,
    AdsTextArea,
    AdsExpansionPanel,
    Alert,
    NewsFilter,
    LocaleSelector
  },
  name: "Settings",
  data() {
    return {
      addNewSchool: false,
      school: null,
      success: false,
      error: false,
      inputText: null,
      aboutThisApp: false,
      selectLocale: false,
      panel: null
    };
  },
  created: function() {
    //eslint-disable-next-line
    NativeJS.debugLog("test debug on settings load");
    //eslint-disable-next-line
    NativeJS.debugLog(`appID: ${this.appID}`);
    //eslint-disable-next-line
    NativeJS.debugLog(`FCM: ${this.fcmToken}`);
    this.$store.dispatch("getSchoolStatus");
  },
  methods: {
    onclose: function() {
      this.error = false;
    },
    onclosesuccess: function() {
      this.success = false;
    },
    filter: function() {
      if (
        this.inputText &&
        this.mySchools.filter(e =>
          e.details.name.toLowerCase().includes(this.inputText.toLowerCase())
        ).length > 0
      ) {
        return this.$t('schoolSetup.error.alreadyAdded');
      } else if (this.inputText) {
        return this.$t('schoolSetup.error.noSchool');
      } else {
        return this.$t('schoolSetup.addSchool.placeholder');
      }
    },
    handleEnter: function() {
      const hasOneItem =
        this.filteredSchools.filter(school =>
          school.name.toLowerCase().includes(this.inputText.toLowerCase())
        ).length === 1;
      if (hasOneItem) {
        this.addSchool();
      }
    },
    addSchool: function() {
      if (this.school) {
        this.$store
          .dispatch("selectSchool", this.school.code)
          .then(() => {
            this.schoolAdded = true;
            this.school = null;
            this.success = true;
            this.addNewSchool = false;
            this.analytics(FA_SCREEN_VIEW, {
              [FA_SCREEN_CLASS]: "my_schools",
              [FA_SCREEN_NAME]: "add_school_complete"
            });
          })
          .catch(() => {
            this.error = true;
          });
      }
    },
    removeSchool: function(school) {
      this.panel = null;
      this.$store.dispatch("removeSchool", {
        schoolId: school.schoolId,
        schoolCode: school.schoolCode,
        redirectToNextSchool: false
      });
    },
    openLink: function(link) {
      //eslint-disable-next-line
      NativeJS.debugLog(`open external link (${link})`);
      //eslint-disable-next-line
      NativeJS.externalLink(link);
    },
    emailLink: function(email) {
      //eslint-disable-next-line
      NativeJS.debugLog(`sending email to ${email}`);
      //eslint-disable-next-line
      NativeJS.emailLink(email);
    },
    getStatus: function(schoolCode) {
      if (this.schoolStatus) {
        return this.schoolStatus.results.find(
          school => school.code == schoolCode
        );
      }
      return null;
    },
    isOperational(data) {
      if (this.hasPassed(data.operationalDate)) {
        return !data.nonOperational;
      } else {
        return data.nonOperational;
      }
    },
    hasPassed(dateString) {
      let date = new Date(dateString);
      let today = new Date();
      return date <= today;
    },
    togglePushNotifications(event, schoolId, type) {
      this.$store.dispatch("setSchoolPushNotifications", {
        schoolId: schoolId,
        type: type,
        value: event
      });
    },
    login() {
      this.analytics("my_account", { sign_in: "tap" });
      this.$store.dispatch("setUserRetries", 0);
      //eslint-disable-next-line
      NativeJS.debugLog(`Logging in`);
      //eslint-disable-next-line
      NativeJS.login();
    },
    logout() {
      this.analytics("my_account", { sign_out: "success" });
      //eslint-disable-next-line
      NativeJS.debugLog(`Logging out`);
      //eslint-disable-next-line
      NativeJS.logout();
      this.$store.dispatch("logout");
    },
    openAboutThisApp() {
      this.aboutThisApp = true;
      this.analytics(FA_SCREEN_VIEW, {
        [FA_SCREEN_CLASS]: "my_schools",
        [FA_SCREEN_NAME]: "about_this_app"
      });
    },
    openLocaleSelector() {
      if (getCookie("nativeLocaleSelector") === "true") {
        //eslint-disable-next-line
        NativeJS.openLocaleSelector();
      } else {
        this.selectLocale = true;
        // this.analytics(FA_SCREEN_VIEW, {
        //   [FA_SCREEN_CLASS]: "my_schools",
        //   [FA_SCREEN_NAME]: "about_this_app"
        // });
      }
    }
  },
  watch: {
    school: function() {
      if (this.school) {
        this.addSchool();
      }
    }
  }
};
export default Settings;
</script>
<style lang="scss" scoped>
h1 {
  font-size: 1.875rem;
  line-height: 2.25rem;
  margin-bottom: 1rem;
}

p {
  line-height: 1.2;
}

.subtitle-1 {
  font-size: 1.125rem !important;
  font-weight: 500 !important;
}

.school-buttons {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  padding: 24px;
  background-color: white;
}

.v-subheader {
  font-size: 1.125rem;
  font-weight: 500;
}

.v-list-item {
  min-height: 0;
}

.v-list-item__title {
  font-size: 1.125rem;
  font-weight: 500;
}

.v-list-item__subtitle {
  font-size: 1rem;
  font-weight: 500;
  white-space: pre-line;
}

.v-btn__content {
  line-height: 1;
}

.v-label {
  font-size: 1rem !important;
}

.school-logo {
  padding: 7px;
  border: 2px solid;
  border-radius: 100px;
}

.v-expansion-panel::v-deep {
  .v-expansion-panel-content__wrap {
    padding: 0;
  }
}

.text-body-1 {
  letter-spacing: 0 !important;
}

hr.v-divider {
  border-color: #c8dcf0;
  max-width: none;
}

.v-autocomplete__content {
  .v-list::v-deep {
    .v-list-item__title {
      color: #407ec9;
      font-weight: 500;
    }
  }
}
</style>
